import { AppRouteProps } from "@harea/component";
import React from "react";

const AdminEmployeeCreateContainer = React.lazy(
    () => import("./container/AdminEmployeeCreateContainer")
);

export const AdminEmployeeCreationRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "Harea.Admin.Employee.Create.Title",
        element: <AdminEmployeeCreateContainer />,
        roles: ["DASHBOARD_ADMIN_RH", "DASHBOARD_MANAGER"],
    },
];